<template>

    <div class="row">

      <div class="col-lg-8">

        <div class="dashboard-block" >
          <ul class="paymentPageActions">
            <li>
              <button type="button" class="paymentPageActions_item" @click="editingBilling = true" >
                <div class="paymentPageActions_icon" >
                  <i class="fa fa-edit"></i>
                </div>
                <div class="paymentPageActions_name">Edit Billing Info</div>
              </button>
            </li>
            <li v-if="$paymentsModuleEnabled">
              <a class="paymentPageActions_item" :href="bookingTncLink()" target="_blank" @click="trackPaymentTermsClick">
                <div class="paymentPageActions_icon" >
                  <i class="fa fa-file-alt"></i>
                </div>
                <div class="paymentPageActions_name">Payment Terms</div>
              </a>
            </li>
            <li v-if="$paymentsModuleEnabled">
              <a class="paymentPageActions_item" href="https://intercom.help/pickstar-help/en/collections/2830220-client#payment" target="_blank" @click="trackPaymentFaqClick">
                <div class="paymentPageActions_icon" >
                  <i class="fa fa-book"></i>
                </div>
                <div class="paymentPageActions_name">Payment FAQs</div>
              </a>
            </li>
          </ul>
        </div>

        <div class="dashboard-block" v-if="editingBilling" >
          <edit-billing-info-form :user="booking.client" @close="editingBilling = false" />
        </div>

        <div class="dashboard-block" v-if="upcomingPayments.length && $paymentsModuleEnabled" >

          <h2>Upcoming</h2>

          <ul class="item-detail item-detail-payment">
            <booking-single-payment-list-item
              v-for="payment in upcomingPayments"
              :key="payment.id"
              :payment="payment"/>
          </ul>

        </div>

        <div class="dashboard-block">

          <h2>{{ $paymentsModuleEnabled ? 'Payment History' : 'Invoices' }}</h2>

          <ul class="item-detail item-detail-payment">

            <li>
              <invoice-item :booking="booking" />
            </li>

            <li v-if="transactions.length && $paymentsModuleEnabled" >
              <transaction-history :transactions="transactions" />
            </li>
          </ul>

        </div>

      </div>

      <div class="col-lg-4">
        <div class="dashboard-block">
          <help-steps v-if="helpSteps.length" :steps="helpSteps" />
        </div>
      </div>

    </div>

</template>

<script>
import { mapState } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingTnc from 'mixins/tnc'
import BookingSinglePaymentListItem from './BookingSinglePaymentListItem'
import BookingAlertTermsAndConditions from './BookingAlertTermsAndConditions'
import HelpSteps from '../globals/HelpSteps'
import TransactionHistory from './TransactionHistory'
import EditBillingInfoForm from './EditBillingInfoForm'
import InvoiceItem from './InvoiceItem'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker, BookingTnc],

  components: {
    BookingSinglePaymentListItem,
    BookingAlertTermsAndConditions,
    HelpSteps,
    TransactionHistory,
    EditBillingInfoForm,
    InvoiceItem
  },

  data () {
    return {
      editingBilling: false
    }
  },

  methods: {
    trackPaymentTermsClick () {
      this.trackEvent(this.analytics.V2.JobPaymentTermsClickEvent, { pageName: this.$route.name, clientSegment: this.booking.segment })
    },

    trackPaymentFaqClick () {
      this.trackEvent(this.analytics.V2.JobPaymentFAQClickEvent, { pageName: this.$route.name, clientSegment: this.booking.segment })
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    upcomingPayments () {
      return this.booking.payments.filter(payment => !payment.paid_date)
    },

    transactions () {
      return this.booking.payments.reduce((transactions, payment) => {
        if (!payment.transaction) {
          return transactions
        }

        let transaction = transactions.find(transaction => transaction.id === payment.transaction.id)

        if (transaction) {
          transaction.payments.push(payment)
        } else {
          transaction = payment.transaction
          transaction.payments = [ payment ]
          transactions.push(transaction)
        }

        return transactions
      }, [])
    },

    helpSteps () {
      if (!this.booking.payments || !this.booking.payments.length || !this.$paymentsModuleEnabled) {
        return [
          {
            title: 'Invoices',
            content: `<p>You will be able to access your invoice here once your booking is confirmed. It may take 1-2 business days for your invoice to appear.</p>`
          }
        ]
      }

      if (this.booking.payments.length > 1) {
        return [
          {
            title: 'Deposit',
            content: `<p>Confirm your booking by paying the deposit amount. This will open up the ability to chat to your ${this.$starLabel}(s).</p>`
          },
          {
            title: 'Final Payment',
            content: `<p>Your final payment is due 7 days before your booking takes place.</p>`
          },
          {
            title: 'Invoices',
            content: `<p>You will be able to access your invoice here once your booking is confirmed. It may take 1-2 business days for your invoice to appear.</p>`
          }
        ]
      }

      return [
        {
          title: 'Payment',
          content: `<p>Your payment is due 7 days before your booking takes place.</p>`
        },
        {
          title: 'Invoices',
          content: `<p>You will be able to access your invoice here once your full payment has been received. It may take 1-2 business days for your invoice to appear.</p>`
        }
      ]
    }
  }
}
</script>
